import Abstract from './abstract';
import Body from 'common/components/v2/guide/body';

export default () => {
  const steps = [
    {
      selector: '[data-guide="course-edit@audit:switch"]',
      content: (
        <Body
          title="仅草稿状态下可编辑"
          description="发布后只有已审核状态的内容可以出现在爱课件中"
        />
      ),
    },
  ];

  return <Abstract steps={steps} scene="editAuditSwitch" />;
};
